import { snapClamp } from './scalar'

export function radiusFromBeamParam(
  s: number,
  step: number = 0.5,
  min: number = 0.5,
  max: number = 50
): number {
  return snapClamp(Math.abs(s), step, min, max)
}

export function heightFromAxisParam(
  s: number,
  step: number = 1,
  min: number = 1,
  max: number = 128
): number {
  return snapClamp(Math.abs(s), step, min, max)
}

export function normalizeShapeDimensions(
  type: 'sphere' | 'cylinder' | 'cone',
  radius: number | undefined,
  height: number | undefined,
): { radius: number; height: number } {
  const normalizedRadius = Math.max(1, Math.round(radius || 1))
  const normalizedHeight = type === 'sphere'
    ? Math.max(1, Math.round(height || normalizedRadius))
    : Math.max(1, Math.round(height || normalizedRadius * 2))
  return { radius: normalizedRadius, height: normalizedHeight }
}

// Move from interactions/shapeHelpers (C30)
export function centerFromStartForShape(
  type: 'sphere' | 'cylinder' | 'cone',
  start: { x: number; y: number; z: number },
  radius: number,
  height?: number,
  axis: 'x' | 'y' | 'z' = 'y',
  axisSign: 1 | -1 = 1
): { x: number; y: number; z: number } {
  const h = height ?? Math.max(1, radius * 2)
  if (type === 'cone') {
    return { x: start.x, y: start.y, z: start.z }
  }
  if (type === 'cylinder') {
    const offset = ((h - 1) / 2) * axisSign
    if (axis === 'y') return { x: start.x, y: start.y + offset, z: start.z }
    if (axis === 'x') return { x: start.x + offset, y: start.y, z: start.z }
    return { x: start.x, y: start.y, z: start.z + offset }
  }
  // Ellipsoid: center offset along axis by its radius (height param)
  const rAxis = height ?? radius
  const offset = rAxis * axisSign
  if (axis === 'y') return { x: start.x, y: start.y + offset, z: start.z }
  if (axis === 'x') return { x: start.x + offset, y: start.y, z: start.z }
  return { x: start.x, y: start.y, z: start.z + offset }
}
